import { useMutation, useQueryClient } from "react-query";
import { AxiosInstance } from "axios";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { useClient } from "utils/client";
import { ControlContext } from "context/Controls";

interface DeleteRiskGroupingTemplateInput {
  crn: string;
}

const deleteRiskGroupingTemplate = async (
  client: AxiosInstance,
  { crn }: DeleteRiskGroupingTemplateInput
) => {
  await client.delete(`/risk-grouping-templates/${crn}`);
};

export const useDeleteRiskGroupingTemplate = () => {
  const client = useClient();
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { displayNotification } = useContext(ControlContext);

  return useMutation(
    async (payload: DeleteRiskGroupingTemplateInput) =>
      await deleteRiskGroupingTemplate(client, payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["riskGroupingTemplates"]);
        displayNotification!(t("notification.saving.generic_success"), "");
      },
      onError: (e) => {
        displayNotification!(
          t("riskTemplate.groupings.error_delete"),
          (e as Error).message,
          "error"
        );
      },
    }
  );
};
